export default __webpack_public_path__ + "static/media/FAQ_5_3.6e9d3f81.png";